import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import noop from 'lodash/noop';
import { Wrapper } from 'roo-ui/components';
import { Label, LabelText } from 'components/Label';
import { themeGet } from 'styled-system';
import { format } from 'lib/date';
import { FOCUS } from 'components/DatePicker/constants';
import InputWithIcon from 'components/InputWithIcon';

const DEFAULT_DATE_FORMAT = 'd MMM';

const formatDate = (date, dateFormat) => {
  if (date) {
    return format(date, dateFormat);
  } else {
    return '';
  }
};

const DateInput = styled(InputWithIcon)`
  &:focus {
    border-color: ${themeGet('colors.blue')};
  }
`;

const PhoneDateDisplay = ({ range, dateFormat, labelOptions, handleFocusedInput, ...rest }) => {
  const handleFocus = useCallback(() => handleFocusedInput(FOCUS.START_DATE), [handleFocusedInput]);
  const onKeyUp = useCallback(
    ({ keyCode }) => {
      if (keyCode === 13) handleFocus();
    },
    [handleFocus],
  );

  const { startDate, endDate } = range;
  const dateInputValue = useMemo(
    () => (startDate || endDate ? `${formatDate(startDate, dateFormat)} - ${formatDate(endDate, dateFormat)}` : 'Select Dates'),
    [startDate, endDate, dateFormat],
  );

  return (
    <Wrapper {...rest}>
      <Label data-testid="phone-date-display">
        <LabelText {...labelOptions} hidden={true}>
          Check in and Check out dates
        </LabelText>
        <DateInput
          left={2}
          icon="calendar"
          borderRadius="default"
          border="1"
          value={dateInputValue}
          onClick={handleFocus}
          onFocus={handleFocus}
          onKeyUp={onKeyUp}
          readOnly
        />
      </Label>
    </Wrapper>
  );
};

PhoneDateDisplay.propTypes = {
  range: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
  }),
  dateFormat: PropTypes.string,
  handleFocusedInput: PropTypes.func,
  labelOptions: PropTypes.object,
};

PhoneDateDisplay.defaultProps = {
  dateFormat: DEFAULT_DATE_FORMAT,
  range: {},
  labelOptions: {},
  handleFocusedInput: noop,
};

export default PhoneDateDisplay;
